import listSaga from './listScanSaga'
import createSaga from './createScanSaga'
import oneScanSaga from './oneScanSaga'
import analyticsSaga from './analyticsSaga'

const scansSagas = [listSaga(), createSaga(), oneScanSaga(), analyticsSaga()]

export default scansSagas
